var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4263 2.29157C10.7278 1.5868 9.87998 1.04792 8.94533 0.714733C8.01068 0.381547 7.01312 0.262566 6.02633 0.366575C2.96799 0.674908 0.451328 3.15824 0.109661 6.21657C-0.348672 10.2582 2.77633 13.6666 6.71799 13.6666C7.97642 13.6666 9.20901 13.3095 10.2726 12.6369C11.3361 11.9642 12.187 11.0036 12.7263 9.86657C12.993 9.30824 12.593 8.66657 11.9763 8.66657C11.668 8.66657 11.3763 8.83324 11.243 9.10824C10.7592 10.1491 9.93163 10.9916 8.89959 11.4939C7.86756 11.9963 6.694 12.1279 5.57633 11.8666C3.72633 11.4582 2.23466 9.94991 1.84299 8.09991C1.67835 7.36846 1.68026 6.60935 1.84857 5.87874C2.01689 5.14813 2.3473 4.4647 2.81537 3.87901C3.28344 3.29332 3.8772 2.82035 4.55272 2.49509C5.22824 2.16983 5.96825 2.00059 6.71799 1.99991C8.10133 1.99991 9.33466 2.57491 10.2347 3.48324L8.97633 4.74157C8.45133 5.26657 8.818 6.16657 9.55966 6.16657H12.5513C13.0097 6.16657 13.3847 5.79157 13.3847 5.33324V2.34157C13.3847 1.59991 12.4847 1.22491 11.9597 1.74991L11.4263 2.29157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.cc08c3227595e683118f68064b44c907.svg";
export { ForwardRef as ReactComponent };